import script from "./ThuHoiB01bTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThuHoiB01bTable.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__